import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { PacsDtoKeysEnum } from '@zaoblako/shared/modules/pacs/enums/pacs-dto-keys.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import type { PassageOrderEmployeeFindInterface } from '@zaoblako/shared/modules/pacs/dtos/passage-order-employee/passage-order-employee-find.dto';

import * as yup from 'yup';

/** Passage order create API request body for personal account mode - DTO signature */
export interface PassageOrderLkCreateInterface {
  /** Client this order belongs to */
  client: ClientFindInterface;
  /** Description this passage order */
  description?: string;
  /** Related employees */
  employees: Pick<PassageOrderEmployeeFindInterface, 'externalUser' | 'rooms'>[];
  /** User who created this passage order */
  createdBy?: UserFindInterface;
}

/** Passage order create API request body for personal account mode - DTO schema */
export const PassageOrderLkCreateDto = SerdeDtoClass.create<PassageOrderLkCreateInterface>(PacsDtoKeysEnum.PASSAGE_ORDER_LK_CREATE_DTO, {
  client: {
    optional: true,
    label: 'Клиент',
    serializer: entityLikeSchema,
  },
  description: {
    optional: true,
    label: 'Описание',
    serializer: yup.string(),
  },
  employees: {
    label: 'Сотрудники',
    serializer: yup.array(yup.mixed()),
  },
  createdBy: {
    optional: true,
    label: 'Пользователь',
    serializer: entityLikeSchema,
  },
});
